import React from "react";

class BuyBanner extends React.Component {
  render() {
    return (
      <div className="banner get-wifi-us-banner">
        <div className="item">
          <img
            className="first-slide img-responsive"
            src="/images/cart-buy.jpg"
            alt="cart-buy"
          />
          <div className="container">
            <div className="carousel-caption">
              <h1>
                Connect to internet with
                <br />
                your smartphone
              </h1>
            </div>
          </div>
          <div className="bottom-text">
            <span>
              BILLING ADDRESS <i className="fa fa-angle-right" />
            </span>
            <span>
              SHIPPING METHOD <i className="fa fa-angle-right" />
            </span>
            <span>
              PAYMENT METHOD <i className="fa fa-angle-right" />
            </span>
            <span>CONFIRM ORDER</span>
          </div>
        </div>
      </div>
    );
  }
}

export default BuyBanner;



// WEBPACK FOOTER //
// ./src/pages/buy/BuyBanner.js